export default __webpack_public_path__ + "static/media/rapid_revision_reg.70854bc7.png";